// import hooks
import { useEffect } from "react";
import isBoolean from "../../common-utils/boolean/isBoolean.util.js";
export const useEventListenerHook = ({ eventName, payload, options, element, }) => {
    useEffect(() => {
        if (!element && !window)
            return;
        if (!payload || (!isBoolean(options) && options?.disabled))
            return;
        if (!isBoolean(options) && options?.runOnInit)
            payload();
        const root = element ?? window;
        root.addEventListener(eventName, payload, options);
        return () => root.removeEventListener(eventName, payload, options);
    }, [eventName, payload, options, element]);
};
export default useEventListenerHook;
